export default __webpack_public_path__ + "static/media/Asset-1Warfighter.05114c3d.svg";